import { Action } from 'redux';
import { put } from '@redux-saga/core/effects';
import { CheckoutActions, CheckoutActionTypes } from '../checkout.types';
import { userHelper, errorToBasketErrorModel, logsHelper } from 'helpers';
import { ErrorAction } from '../../root.types';
import { BasketSagaReturnType } from 'store/sagaHelpers';
import { BasketDetailsModel } from 'models/Basket';
import { api } from 'repositories/api';
import { BasketActions, BasketActionTypes } from 'store/basket';

export interface TransferBasketAction extends Action<CheckoutActionTypes.TRANSFER_BASKET> {
    basketId: string;
}

export interface TransferBasketActionStart extends Action<CheckoutActionTypes.TRANSFER_BASKET_START> {
}

export interface TransferBasketActionSuccess extends Action<CheckoutActionTypes.TRANSFER_BASKET_SUCCESS> {
}

export interface TransferBasketActionError extends ErrorAction<CheckoutActionTypes.TRANSFER_BASKET_ERROR> {
}

export function* transferBasketSaga({ basketId }: TransferBasketAction): BasketSagaReturnType {
    yield put<CheckoutActions>({
        type: CheckoutActionTypes.TRANSFER_BASKET_START
    });

    try {
        const user = userHelper.getUser();
        const username = user!.username!;

        const transferredBasket: BasketDetailsModel = yield api.hybris.transferBasket(username, basketId);

        try {
            // only for sending email about abandoned basket
            yield api.rabbit.basketCreated(basketId, username);
        } catch (error) {
            logsHelper.error(error);
        }

        // sometimes userId could be null after login/registration - this is API problem

        yield put<BasketActions>({
            type: BasketActionTypes.CLEAR_BASKET
        });

        userHelper.saveSessionId(transferredBasket.session.sessionId);

        yield put<CheckoutActions>({
            type: CheckoutActionTypes.TRANSFER_BASKET_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.TRANSFER_BASKET_ERROR,
            error: errorToBasketErrorModel(error, 'transferBasketSaga')
        });

        return false;
    }
}